const rand = () => Math.floor(Math.random() * 1e7);

export { rand };
